import { render, staticRenderFns } from "./SelectFieldsCheckboxes.vue?vue&type=template&id=2f15c368&scoped=true&lang=pug&"
import script from "./SelectFieldsCheckboxes.vue?vue&type=script&setup=true&lang=js&"
export * from "./SelectFieldsCheckboxes.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SelectFieldsCheckboxes.vue?vue&type=style&index=0&id=2f15c368&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15c368",
  null
  
)

export default component.exports